import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import FlowService from '../../services/flow-service';
import { redirectToCanonicalHostIfNeeded } from '../../utils/auth-utils';

// Flow 391 is the 'nhs' slug flow — stable across environments
const NHS_FLOW_ID = 391;

const CreateAccountPreFlow: React.FC = () => {
  const { search } = useLocation();

  useEffect(() => {
    // Normalize to www. so the entire create-account + Auth0 callback runs on the
    // same origin. buildCanonicalRedirectUri() always produces www., so without this
    // redirect the localStorage and sl-user-flow cookie written here (sleepiodev.com)
    // are invisible to the callback (www.sleepiodev.com).
    if (redirectToCanonicalHostIfNeeded()) {
      return;
    }

    const params = new URLSearchParams(search);
    const redirectUrl = params.get('redirect_url') ?? '';
    const qs = redirectUrl
      ? `?redirect_url=${encodeURIComponent(redirectUrl)}`
      : '';

    // Always pre-warm flow 391 at #2/1 (country selector) and redirect to /sleepio/nhs.
    // Vanity flows (nhs-sleepio, wales, etc.) have different API-assigned IDs, so the
    // pre-warm only works reliably for flow 391. flow.container gates its country-cookie
    // redirect on login_mode=true, so Create Account always stays on /sleepio/nhs.
    FlowService.setLocalProgress(NHS_FLOW_ID, 1, 0);
    window.location.replace(`/sleepio/nhs${qs}`);
  }, [search]);

  return null;
};

export default CreateAccountPreFlow;
